/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-08-13 16:57:25
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';

import BsyUserCheckBox from '../../BsyUserCheckBox';
import BsySelectListCheckBox from '../../BsySelectListCheckBox';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterUserGroup extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            customItem: {
                text: React.language("unfilled"),
                value: "hasEmpty"
            },
            displayType: {
                list: "checklist",
                box: "usercheck"
            },
            ...props
        })

        this.dashText = null;
    }

    doFilterRely = (t, rel, widgetFilter) => {
        this.filterRely = t;
        this.rel = rel;
        this.dashText && this.dashText.doFilterRely && this.dashText.doFilterRely(t, rel, widgetFilter)
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN,
        BsyConfig().CONST.FILTER_METHOD.ALL,
        BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }

    getValue = () => {
        let t = this.options;
        if (this.dashText) {
            let e = this.dashText.getValue()

            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.ALL:
                case BsyConfig().CONST.FILTER_METHOD.IN:

                    if (BsyUtils.isObjectEmpty(e))
                        return { items: [], hasEmpty: false };
                    let e1 = [].concat(e)
                        , t = !1
                        , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                    if (i > -1) {
                        t = !0
                        e1.splice(i, 1)
                    }
                    return {
                        hasEmpty: t,
                        items: e1
                    }
                // return e;
                default:
                    return null
            }

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
        if (this.filterRely) {
            this.doFilterRely(this.filterRely, this.rel)
        }
    }

    renderCont = () => {
        let { appId, entryId } = this.options;
        let e = this
        let i = this.options;
        let val = this.getMiddleValue() || {};
        let c = this._getAsyncConfig();
        if (BsyUtils.isObjectEmpty(c)) {
            this.dashText = null;
            return <span className='error-tip'>{React.language("field.deleted.tip1")}</span>;
        }
        if (!c.data.hasOwnProperty('hasCurrentUser')) {
            c.data.hasCurrentUser = true;
        }
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.ALL:
            case BsyConfig().CONST.FILTER_METHOD.IN:
                // this._createComboCheck();
                let vals = [];
                if (val.hasEmpty) {
                    vals.push(BsyConfig().CONST.PARAMETER.EMPTY)
                }
                if (val.items)
                    vals = vals.concat(val.items);
                if (i.height > i.minRow) {
                    return <BsySelectListCheckBox
                        getContext={this.getContext}
                        theme={this.props.theme}
                        asyncResultKey={i.asyncResultKey || "items"}
                        hasLimit={!0}
                        value={vals}
                        onBeforeAsync={i.onBeforeAsync}
                        textField={'nickname'}
                        valueField={"_id"}
                        hasSelectEmpty={false}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        async={c}
                    />
                } else {
                    return <BsyUserCheckBox
                        getContext={this.getContext}
                        theme={this.props.theme}
                        hasLimit={!0}
                        asyncResultKey={i.asyncResultKey || "items"}
                        value={vals}
                        height={'34px'}
                        textField={'nickname'}
                        valueField={"_id"}
                        hasSelectEmpty={false}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'
                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        async={c}
                    />
                }

            default:
                break;
        }


    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

